/* ==========================================================================
   Premium Home — Shared JavaScript
   Vanilla JS only. No dependencies.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------------- Scroll reveal (fade-up / fade-in) ---------------- */
  function initScrollReveal() {
    var targets = document.querySelectorAll('.ph-fade-up, .ph-fade-in');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    targets.forEach(function (el) {
      var section = el.closest('[data-animate]');
      if (section && section.getAttribute('data-animate') === 'false') {
        el.classList.add('is-visible');
        return;
      }
      observer.observe(el);
    });
  }

  /* ---------------- Product gallery: thumbnail swap ---------------- */
  function initGalleries() {
    var galleries = document.querySelectorAll('.ph-gallery');
    galleries.forEach(function (gallery) {
      var mainImg = gallery.querySelector('.ph-gallery-image');
      var thumbs = gallery.querySelectorAll('.ph-thumb');
      if (!mainImg || !thumbs.length) return;

      thumbs.forEach(function (thumb) {
  thumb.addEventListener('click', function () {
    var fullSrc = thumb.getAttribute('data-full');

    if (fullSrc) {
      mainImg.src = fullSrc;
      mainImg.srcset = "";
    }

    thumbs.forEach(function (t) {
      t.classList.remove('is-active');
    });

    thumb.classList.add('is-active');
  });
});
    });
  }

  /* ---------------- Quantity stepper ---------------- */
  function initQuantitySteppers() {
    document.querySelectorAll('.ph-qty-stepper').forEach(function (stepper) {
      var input = stepper.querySelector('.ph-qty-input');
      var minus = stepper.querySelector('.ph-qty-minus');
      var plus = stepper.querySelector('.ph-qty-plus');
      if (!input) return;

      function setValue(v) {
        var min = parseInt(input.getAttribute('min'), 10) || 1;
        var newVal = Math.max(min, v);
        input.value = newVal;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (minus) {
        minus.addEventListener('click', function () {
          setValue((parseInt(input.value, 10) || 1) - 1);
        });
      }
      if (plus) {
        plus.addEventListener('click', function () {
          setValue((parseInt(input.value, 10) || 1) + 1);
        });
      }
    });
  }

  /* ---------------- Variant option -> hidden id input sync ---------------- */
  function initVariantSelectors() {
    document.querySelectorAll('.ph-product-form').forEach(function (form) {
      var selects = form.querySelectorAll('.ph-select');
      var idInput = form.querySelector('.ph-variant-id-input');
      if (!selects.length || !idInput) return;

      // Variant data is optional: if a merchant needs live price/variant swap,
      // this hook provides the integration point without adding a hard dependency.
      selects.forEach(function (select) {
        select.addEventListener('change', function () {
          form.dispatchEvent(new CustomEvent('ph:option-change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------------- Science bar chart animation trigger ---------------- */

  /* ---------------- Init on DOM ready ---------------- */
  function init() {
    initScrollReveal();
    initGalleries();
    initQuantitySteppers();
    initVariantSelectors();
    // showBars();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init reveal/bars when Shopify theme editor injects/reorders sections */
  document.addEventListener('shopify:section:load', init);
})();
